<template>
    <div>
        <dialog class="gradient rounded" style="border: 2px solid white; color: white;" ref="confirm-dialog">
            <h3>Account deleted successfully</h3>
            <hr/>
            <span>You will be redirected shortly to main page.</span>
            <div style="width: 100%; display: flex; justify-content: end;">
                <Button style="padding: 3px 10px; margin: 15px 10px 5px 0px;" buttonClass="exit-button" @click="exit">Back to Main Page</Button>
            </div>
        </dialog>
        <div>
            <div class="top-logo-bar" style="display: flex; align-items: center;" >
                <router-link :to="{name: 'login'}" style="align-items: left; display: flex">
                    <img class="app-logo" src="~@/assets/img/Menu/Logo.svg" style="margin-left:10vw ; height:35px; margin-top:0px; padding-right: 20px; border-right: 1px solid #AEAEAE7F"/>
                    <img class="app-logo" src="~@/assets/img/Menu/TransparencyLogo.svg" style="margin-left:20px;height:35px;margin-top:0px;"/>
                </router-link>
            </div>
        </div>
        <div class="policy-container">
            <h2 class="main-header">Delete Account</h2>
            <div class="col-sm-12 col-md-12 col-lg-4 gradient rounded p-5 m-4" style="max-width: 100%; margin: 24px 0 !important;">
                <div style="padding-bottom: 30px;">
                    <div>
                        <p class="label text-left">
                            By filling this form you can delete your CRFI Monitoring account. Data that will be deleted contains your:<br/> 
                            <ul>
                                <li>Name and Surname</li>
                                <li>Email Address</li>
                                <li>Phone Number</li>
                                <li>Connection to System</li>
                                <li>Country of origin</li>
                            </ul>
                        </p>
                    </div>
                    <div>
                        <p class="label text-left mt-4 mb-1">E-MAIL</p>
                    </div>
                    <div>
                        <input type="email" name="email" id="email"
                        v-model="email" class="form-control no-radius p-0" placeholder="Enter your e-mail" maxlength="50" @input="emailChange" @blur="emailChange"/>
                        <span v-if="this.emailErrorMsg.length != 0" class="error">{{this.emailErrorMsg}}</span>
                    </div>
                    <div>
                        <p class="label text-left mt-4 mb-1">PASSWORD</p>
                    </div>
                    <div>
                        <input type="password" name="password" id="password"
                        @keyup.enter="confirm"
                        v-model="password" class="form-control no-radius p-0" placeholder="Enter your password" maxlength="100" aria-describedby="password-help-block" @input="passwordChange" @blur="passwordChange"/>
                        <span v-if="this.passwordErrorMsg.length != 0" class="error">{{this.passwordErrorMsg}}</span>
                    </div>
                    <div>
                        <p class="label text-left mt-4 mb-1">REPEAT PASSWORD</p>
                    </div>
                    <div>
                        <input type="password" name="password-rep" id="password-rep"
                        @keyup.enter="confirm"
                        v-model="passwordRepeat" class="form-control no-radius p-0" placeholder="Repeat your password" maxlength="100" aria-describedby="password-help-block" @input="passwordRepeatChange" @blur="passwordRepeatChange"/>
                        <span v-if="this.passwordRepeatErrorMsg.length != 0" class="error">{{this.passwordRepeatErrorMsg}}</span>
                    </div>
                    <CheckBoxCrfi style="margin: 10px 0;" :checkboxError="checkboxError" :noMargin="true" :label="'I want to delete my CRFI Monitoring account and understand that I will lose access to portal.'" @onChange="changeConfirmCheckbox"/>
                    <div class="d-flex flex-column my-1 pt-3">
                        <div class="d-flex flex-row mb-1">
                            <Button class="px-3 py-3 mt-3" buttonClass="semi-bold confirm-button flex-grow-1" :title="'Submit'" @onClick="confirm"/>
                        </div>
                        <div class="d-flex flex-row mb-1" style="justify-content: center;">
                            <span v-for="item in serverErrors" class="error" :key="item">{{item}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/Button.vue';
import CheckBoxCrfi from '@/components/CheckBoxCrfi.vue';

import { loginUser, deleteOwnAccount } from '@/api/api';
import axios from 'axios';

export default {
    components: {
        Button,
        CheckBoxCrfi
    },
    data() {
        return {
            emailErrorMsg: '',
            passwordErrorMsg: '',
            passwordRepeatErrorMsg: '',
            email: '',
            password: '',
            passwordRepeat: '',
            serverErrors: [],
            checkboxError: '',
            confirmCheckbox: false
        }
    },
    methods: {
        passwordChange(_) {
            this.passwordRepeatErrorMsg = '';
            this.passwordErrorMsg = '';

            if(this.password.length == 0) {
                this.passwordErrorMsg = 'Required';
            }

            if (this.password != this.passwordRepeat) {
                this.passwordRepeatErrorMsg = 'Passwords must match.';
            }
        },
        emailChange() {
            this.emailErrorMsg = ''
            if (this.email.length == 0) {
                this.emailErrorMsg = 'Required';
                return;
            }

            if(!this.email.match(
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
                this.emailErrorMsg = 'Email not valid.'
            }
        },
        async confirm(){
            if (!this.confirmCheckbox) {
                this.checkboxError = 'Confirmation required.';
            }

            if(this.password.length == 0) {
                this.passwordErrorMsg = 'Required';
            }

            if (this.passwordRepeat.length == 0) {
                this.passwordRepeatErrorMsg = 'Required';
            }

            if (this.email.length == 0) {
                this.emailErrorMsg = 'Required';
            }

            if (this.passwordRepeatErrorMsg.length > 0 || this.passwordErrorMsg.length > 0 || this.checkboxError.length > 0 || this.emailErrorMsg.length > 0 || this.email.length == 0 || this.password.length == 0 || this.passwordRepeat.length == 0 || !this.confirmCheckbox) {
                // Do nothing
                return;
            } else {
                var user = {
                    Password: this.password,
                    Email: this.email
                }

                loginUser(user)
                    .then(response => {
                        const token = response.data.token;
                        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

                        deleteOwnAccount()
                            .then(_ => {
                                this.$refs['confirm-dialog'].showModal();
                                setTimeout(this.exit, 7000)
                            })
                            .catch(error => {
                                this.serverErrors = ['Login/password incorrect.'];

                                if(error == 'Unauthorized access'){
                                    this.serverErrors = ['Unauthorized Role']
                                } else {
                                    this.serverErrors = ['Login/password incorrect.'];
                                }
                            })
                    })
                    .catch((error) => {
                        this.serverErrors = ['Login/password incorrect.'];

                        if(error == 'Unauthorized access'){
                            this.serverErrors = ['Unauthorized Role']
                        } else {
                            this.serverErrors = ['Login/password incorrect.'];
                        }
                    });
                
            }
        },
        changeConfirmCheckbox(value) {
            this.checkboxError = '';
            this.confirmCheckbox = value;

            if(!this.confirmCheckbox) {
                this.checkboxError = 'Confirmation required.';
            }
        },
        passwordRepeatChange(_) {
            this.passwordRepeatErrorMsg = '';

            if (this.passwordRepeat != this.password) {
                this.passwordRepeatErrorMsg = 'Passwords must match.';
            }
        },
        exit() {
            this.$store.dispatch('logout');
            this.$router.push('/');
        }
    },
    mounted: async function() 
    {
        this.$store.dispatch('logout');
    }
}
</script>

<style scoped>
.top-logo-bar {
    width: 100%;
    height: 100px;
    background: #347C93;
}

.section-header {
    margin-bottom: 20px;
    margin-top: 40px;
    font-weight: 600;
    font-size: 24px;
}

.main-header {
    font-weight: 700;
    font-size: 1.4rem;
    margin-top: 20px;
    justify-content: center;
    align-content: center;
    width: 100%;    
}

section {
    padding-right: 40vw;
}

p {
    text-align: justify;
    /* margin-left: 2vw; */
}

li {
    font-weight: 700;
}

.policy-container {
    height: calc(100% - 100px); 
    overflow-y: scroll; 
    padding-left: calc(15vw + 30px);
    padding-right: calc(15vw + 30px);
}

@media only screen and (max-width: 700px) {
    .policy-container {
        padding-left: 5%;
        padding-right: 5%;
    }

    section {
        padding-right: 5%;
    }
}


.gradient {
        background-image: linear-gradient(#31929f, #356a86);
    }

    .label {
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 0.8rem !important;
        color: white;
    }

    p {
        color: white;
    }

    .underlined {
        text-decoration: underline;
    }

    .bold {
      font-weight: bold;
    }

    .bg {
      text-align: center;
      background-color: white;
      background-image: url('~@/assets/img/cows.jpg');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: left top;
    }

    .error {
        text-align: left !important;
        color: #FD8282;
        font-size: 11px;
        font-weight: bold;
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 400 !important;
    }

    input {
        background: transparent;
        border: none;
        border-bottom: 1px solid white;
        padding-left: 0;
        font-size: 1rem;
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 400 !important;
        padding-left: 10px;
        color: #ADD0D7;
    }

    input:focus {
        background: transparent;
        border: none;
        border-bottom: 1px solid white;
        padding-left: 0;
        font-size: 1rem;
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 400 !important;
        padding-left: 10px;
        color: #ADD0D7;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
        border: 0px solid green;
        -webkit-text-fill-color: #ADD0D7;
        -webkit-box-shadow: 0 0 0px 0px transparent inset;
        transition: background-color 5000s ease-in-out 0s;
        border-bottom: 1px solid white;
    }

    input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: rgb(166, 194, 205);
    }

    .footer {
        position: absolute;
        bottom: 0;
    }

    .lightColor {
        color: rgb(142, 171, 185);
        background: rgb(142, 171, 185);
    }

    .themeColor {
        color: rgb(51, 123, 145);
        background: rgb(51, 123, 145);
    }

    .rounded {
        border-radius:.75rem !important;
    }

    .no-radius {
        border-radius: 0;
    }

    .exit-button {
        color: white;
        background: none;
        border: white 1px solid;
        border-radius: 15px;
        transition-duration: .3s;
    }

    .exit-button:hover {
        background: white;
        color: rgb(55, 55, 55);
        border: rgb(55, 55, 55) 1px solid;
    }
    
    .confirm-button {
        color: white;
        background: rgb(143, 209, 170);
        border-radius: 30px;
        border: none;
        font-size: 15px;
    }

    .login-button {
        color: white;
        background: transparent;
        border: none;
    }

    .noselect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    dialog::backdrop {
        background-color: black;
        opacity: 0.75;
    }
</style>


// WEBPACK FOOTER //
// src/views/Users/DeleteUserForm.vue